import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  userAssets: {},
  allUserAssets: [],
  allUserAssetsBTCValues: {},
};

const _handleUserAssets = data => {
  const userAssets = {
    totalTransferBtc: data.totalBtc,
  };
  data.details &&
    data.details.map(v => {
      userAssets[v.asset] = v.btcValue;
      return null;
    });
  return userAssets;
};

const _handleAllUserAssets = data => data.map(item => {
  item.total =
      Number(item.free) + Number(item.locked) + Number(item.freeze) + Number(item.withdrawing);
  return item;
});

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_ASSETS:
      return { ...state, userAssets: action.data };
    case actionTypes.SET_ALL_USER_ASSETS:
      return { ...state, allUserAssets: _handleAllUserAssets(action.data) };
    case actionTypes.SET_ALL_USER_ASSETS_BTC_VALUES:
      return { ...state, allUserAssetsBTCValues: _handleUserAssets(action.data) };
    default:
      return state;
  }
};
